import { useQuery, UseQueryResult } from 'react-query';
import { MonitorDto } from '../../../services/dtos/riskProducts/monitor.dto';
import { fetchMonitor } from '../../../services/riskProducts/riskProducts.service';
import { queryKeys } from '../../queryKeyFactory';

const sortByDisplayNameAsc = (monitorDtos: MonitorDto[]): MonitorDto[] => {
  return Array.from(monitorDtos?.values()).sort((monitorDto1: MonitorDto, monitorDto2: MonitorDto): number => {
    const name1 = monitorDto1.display_name;
    const name2 = monitorDto2.display_name;
    return name1.localeCompare(name2);
  });
};

const useFetchMonitor = (watchListId: string): UseQueryResult<MonitorDto[]> => {
  return useQuery<MonitorDto[], Error>(queryKeys.fetchRiskProducts.dashboard.monitor(watchListId), async () => {
    const data = await fetchMonitor(watchListId);
    return sortByDisplayNameAsc(data);
  });
};

export default useFetchMonitor;
